import styled from 'styled-components';

export const StyledShopCard = styled.div`
  width: 100%;
  height: 100%;
  padding: 15px;
  text-align: center;
`;

export const CallToActionText = styled.span`
  display: block;
  flex: 0 0 auto;
  font-weight: 600;
  padding: 10px;
  background: #f5f9fb;
  color: ${p => p.theme.text.callToAction};
`;

export const ShopButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  cursor: pointer;
  width: 100%;
  height: 100%;
  box-shadow: 0 0 5px 0 ${p => p.theme.colors.base200};
  transition: box-shadow 0.1s linear;
  &:hover {
    box-shadow: 0 0 5px 0 ${p => p.theme.colors.base300};
    ${CallToActionText} {
      color: ${p => p.theme.text.callToActionHover};
    }
  }
  &:focus {
    box-shadow: 0 0 0 2px ${p => p.theme.colors.positive500};
    ${CallToActionText} {
      color: ${p => p.theme.text.callToActionHover};
    }
  }
`;

export const LogoWrapper = styled.span`
  display: block;
  flex: 0 0 auto;
  padding: 15px;
  margin: auto 0;
`;
